<template>
  <div class="queries">
    <h1 class="page-title">
      <router-link to="/queries">Queries</router-link>
      <span class="divider">&rsaquo;</span>
      Create Query
    </h1>

    <ul class="page-actions">
      <li></li>
    </ul>

    <query-form
      :query="query"
      :form-state="formState"
      :errors="errors"
      @submit="create"
      @revertState="formState = 'normal'"
    ></query-form>
  </div>
</template>

<script>
import { mapState } from "vuex";

import queryForm from "@/components/queryForm/main";
import auth from "@/helpers/auth";

export default {
  components: { queryForm },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },

  data() {
    return {
      formState: "normal",
      errors: {},
      query: {
        id: null,
        label: "",
        matcher_type: "and",
        matchers: [],
        on_match: {
          responses: [],
          move_to_query: null,
          set_next_query: null,
          setters: [],
          form_fields: []
        },
        on_mismatch: {
          responses: [],
          move_to_query: null,
          set_next_query: null,
          setters: [],
          form_fields: []
        }
      }
    };
  },

  computed: {
    ...mapState({
      queries: (state) => state.queries.all
    })
  },

  watch: {
    queries(all) {
      this.$router.push("/queries/" + all[all.length - 1].id);
    }
  },

  methods: {
    create(params) {
      this.formState = "loading";

      this.$store
        .dispatch("createQuery", params)
        .then((resp) => {
          this.formState = "done";
          this.errors = {};
        })
        .catch((err) => {
          this.errors = err.response.data.errors;
          this.formState = "normal";
        });
    }
  }
};
</script>
